import { createApi } from "@/api/ApiFactory";
import { config } from "@/config/config";

const AuswahlwerteApi = createApi(config.AUSWAHLWERTE_API_URL);

export default AuswahlwerteApi;
